import routerOptions0 from "/builds/netzfabrik/apanel/backbone-api/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}